import React from 'react';
import {qsToObject} from './utils'
// import './copy/css/style-front.css';

import WhatsOnListingEvents from './WhatsOnListingEvents';
import WhatsOnListingClasses from './WhatsOnListingClasses';

function WhatsOnListingWrap() {
    const queriesObject = qsToObject(window.location.search);
    let tabValue = queriesObject.WhatsOnTab || null;
    let activeEvent = true;

    let configEvents = window.whatsonConfig || null;
    let configClasses = window.whatsonClassesConfig || null;

    let hideClasses = true;
    if (configClasses && configClasses.culture === "en-US") {
        hideClasses = false;
    }

    const eventTabName = configEvents.tabEventName || "";
    const classTabName = configClasses.tabClassName || "";

    if (tabValue && tabValue === "Class") {
        activeEvent = false;
    }

    if (hideClasses === true) {
        activeEvent = true;
    }


    const [tabList, setTabList] = React.useState([{
        tabName: eventTabName,
        active: activeEvent,
        hide: false,
    },
    {
        tabName: classTabName,
        active: !activeEvent,
        hide: hideClasses,
    }]);



    const changeActiveTab = (tab) => {
        if (!tab.active) {
            const tabListModified = tabList.map((item) => {
                if (item.tabName === tab.tabName) {
                    item.active = !item.active;
                } else {
                    item.active = false
                }
                return item;
            });
            setTabList(tabListModified)
        }
    }

    return <div className={`whaton-new-module ${tabList[0].active ? "whaton-new-module--events" : "whaton-new-module--classes"}`}>
        {
            tabList[0].active ?
                <WhatsOnListingEvents tabList={tabList} changeTab={changeActiveTab} whatsonListing={true} /> :
                <WhatsOnListingClasses tabList={tabList} changeTab={changeActiveTab} whatsonListing={true} />
        }
    </div>;
}

export default WhatsOnListingWrap;


